import { RequiredIndicator } from '@wix/ambassador-forms-v4-form-http/types';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import React, { useMemo } from 'react';
import { useConfig } from '../../contexts/config-context';
import { useFieldAttributes } from '../../sdk/components';
import { FieldDescriptionWUT, FieldLabelWUT } from '../../sdk/components-wut';
import { formatCurrency } from '../../utils/format-currency';
import { classes } from './fixed-payment-field-wut.st.css';
export const FixedPaymentFieldWUT = ({ id, label, hideLabel = false, required = false, error, description, validation, FieldLayout })=>{
    const { labelId, inputId, descriptionId } = useFieldAttributes(id, error, description);
    const { currency, regionalFormat } = useConfig();
    const paymentValidation = useMemo(()=>validation?.predefined?.paymentOptions?.products?.[0], [
        validation
    ]);
    const fixedPaymentValue = paymentValidation?.fixedPriceOptions?.price;
    const formattedValue = formatCurrency({
        amount: fixedPaymentValue,
        currency: currency?.code,
        locale: regionalFormat
    });
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: RequiredIndicator.NONE
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(Text, {
                className: classes.text,
                id: inputId,
                "data-hook": "fixed-payment-value",
                "aria-hidden": "false"
            }, formattedValue),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            })
    });
};

//# sourceMappingURL=fixed-payment-field-wut.js.map